
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";

@Component
export default class UI extends ElementTableView {
  items = [
    {
      type: "",
      label: "标签一"
    },
    {
      type: "success",
      label: "标签二"
    },
    {
      type: "info",
      label: "标签三"
    },
    {
      type: "danger",
      label: "标签四"
    },
    {
      type: "warning",
      label: "标签五"
    }
  ];
}
